




























import Vue from 'vue'
import { mapGetters } from 'vuex'
import AlertBar from '@/components/AlertBar.vue'
export default Vue.extend({
    components: { AlertBar },
    data() {
        return {
            accepted: false,
            alert: false,
            error: `Please agree to the Terms of Service, Privacy Policy, and Use Agreement`,
            label: `I agree to the MessageDesk Terms of Service, Privacy Policy, and Use Agreement.`,
            loading: false
        }
    },
    mounted() {
        this.$store.dispatch('loadTermsOfService')
    },
    computed: {
        ...mapGetters(['privacyPolicy', 'termsOfService', 'useAgreement', 'user']),
        items() {
            return [
                {
                    title: 'Terms of Service',
                    content: this.termsOfService
                },
                {
                    title: 'Privacy Policy',
                    content: this.privacyPolicy
                },
                {
                    title: 'Use Agreement',
                    content: this.useAgreement
                }
            ]
        }
    },
    methods: {
        async accept(): Promise<boolean> {
            //  Validate the form
            const valid = this.accepted === true

            //  If the form is NOT valid, pop alert
            if (!valid) return (this.alert = true)

            //  Else, Set terms true on the currently authenticated user
            this.user.terms_accepted = true

            //  Start the loader
            this.loading = true

            //  Send update request to the API
            await this.$store.dispatch('authUserPut', this.user)

            //  Get user with tenant's person
            const user = await this.$store.dispatch('usersFind', this.user.id)

            //  Set auth user to user with tenant's person
            if (user) this.$store.commit('authUserSet', user)

            //  Stop the loader
            this.loading = false

            //  If the update failed, no nothing
            if (!user) return

            //  Else, close the app dialog
            this.$store.commit('dialogCloseAll', 'APP')

            //  Ask user for browser notification permission after accepting terms
            this.checkNotificationPromise()
        },
        //Check browser notification permission
        checkNotificationPromise(): boolean {
            try {
                Notification.requestPermission().then()
            } catch (e) {
                return false
            }
            return true
        }
    }
})
